<template>
<!--组件实例地址 http://localhost:8080/example -->
	<div id="home">
		首页
		<div class="box"></div>
		<el-popover placement="top-start" title="标题" width="200" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
			<el-button slot="reference">hover 激活</el-button>
		</el-popover>

		<el-popover placement="bottom" title="标题" width="200" trigger="click" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
			<el-button slot="reference">click 激活</el-button>
		</el-popover>

		<el-popover ref="popover" placement="right" title="标题" width="200" trigger="focus" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
		</el-popover>
		<el-button v-popover:popover>focus 激活</el-button>

		<el-popover placement="bottom" title="标题" width="200" trigger="manual" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。" v-model="visible">
			<el-button slot="reference" @click="visible = !visible">手动激活</el-button>
		</el-popover>
    <!-- 多选，展示+1.. -->
		<el-select v-model="value2" multiple collapse-tags style="margin-left: 20px;" placeholder="请选择">
			<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
			</el-option>
		</el-select>
    <!-- 表格 -->
		<div class="tabOffTop120">
			<!-- v-loading="loading" element-loading-text="数据正在努力加载中"  -->
			<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column label="日期" width="120">
					<template slot-scope="scope">{{ scope.row.date }}</template>
				</el-table-column>
				<el-table-column prop="name" label="姓名" width="120">
				</el-table-column>
				<el-table-column prop="address" label="地址" show-overflow-tooltip>
				</el-table-column>
				<el-table-column label="操作" min-width="150">
					<template slot-scope="scope">
						<a href="javascript:;" class="operate-a">详情</a>
						<a href="javascript:;" class="operate-a">编辑</a>
					</template>
				</el-table-column>

			</el-table>
		</div>
		</el-table>
		<div style="margin-top: 20px">
			<el-button @click="toggleSelection([tableData[1], tableData[2]])">切换第二、第三行的选中状态</el-button>
			<el-button @click="toggleSelection()">取消选择</el-button>
		</div>
    <!-- 开关 -->
		<el-switch v-model="value" active-color="#70CE97" inactive-color="#cccccc">
		</el-switch>
    <!-- 分页条 -->
		<ybPagination :page="page" @size-change="pageSizeChange" @current-change="pageCurrentChange" style="margin-top:10px;">
		</ybPagination>
   
    <!-- 有搜索的input -->
		<el-input placeholder="输入文对对对" class="w250 seekIpt mr20" v-model="input">
			<i slot="suffix" class="el-input__icon el-icon-search"></i>
		</el-input>
    <!-- 按钮相关 -->
		<el-button>默认按钮</el-button>
		<el-button type="primary" class="mr20">主要按钮</el-button>
		<el-button class="selectHeight mr20" type="primary">
			<i style="margin-right: 5px;font-weight: 700;color: #fff;" class="el-icon-plus"></i>新增
		</el-button>
    <!-- 单选框 -->
		<el-select v-model="value1" class="mr20" placeholder="请选择">
			<el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
			</el-option>
		</el-select>
    <!-- 表单模板 -->
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
			<ToggleForm title="表单模板">
				<div class="content">
					<div class="row">
						<el-form-item label="巡查时间:" prop="patrolTime">
								<el-date-picker class="w200" v-model="ruleForm.patrolTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
								</el-date-picker>
						</el-form-item>
					</div>
					<div class="row">
						<el-form-item label="巡查时间:" prop="patrolTime1">
								<el-date-picker class="w200" v-model="ruleForm.patrolTime1" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
								</el-date-picker>
						</el-form-item>
					</div>
					<div class="row">
						<el-form-item label="巡查时间:" prop="patrolTime1" class="clear_a">
								<el-checkbox-group v-model="ruleForm.spaceDst" size="large">
									<el-checkbox-button v-for="(item,index) in spaceDstSelect" :label="item.code" :key="item.id+index">{{item.name}}</el-checkbox-button>
								</el-checkbox-group>
						</el-form-item>
					</div>
					<div class="row rowybUpload">
						<el-form-item label="上传图片：">
							<p class="rowybUploadText w400">上传图片大小不超过10M；上传格式：jpg、png、gif，只能上传1张图片。</p>
							<ybUpload :maxLength=2 @uploadSuccess='getFiles' @uploadError="getFiles"
							 @remove='getFiles' :filesArr='filesArr'></ybUpload>
							 <!-- filesArr:[],回显的时候必传 -->
						</el-form-item>
					</div>
				</div>
			</ToggleForm>
		</el-form>
		<wangeditor :isClear='false' v-model="content" @change="ischange"></wangeditor>
		
	</div>
</template>

<script>
	import * as api from "api/com";
	import ybPagination from 'components/ybPagination';
	import ToggleForm from "components/ToggleForm";
	import ybUpload from "components/ybUpload";
	import wangeditor from "components/wangeditor";
	export default {
		components: {
			ybPagination,
			ToggleForm,
			ybUpload,
			wangeditor
		},
		name: "home",
		data() {
			return {
				content:'',
				filesArr:[{
					name:'3IMPOvKWJ5i1c0b249b7db664d9992958d159c8f71fb.jpg',
					fileId:"303a3c849901523554b71d1a452eefc9",
					url:"https://stg-bucket.oss-cn-hangzhou.aliyuncs.com/mealguard_prod/76E7332944EC415EB89D877DBD09B21C/2019-06-27YGzd77Cs2QQbwEcszttG.jpg"
				},{	
					name:'3IMPOvKWJ5i1c0b249b7db664d9992958d159c8f719b.jpg',
					fileId:"f82a4e416189df617eeab4a010ac7b53",
					url:"https://stg-bucket.oss-cn-hangzhou.aliyuncs.com/mealguard_prod/76E7332944EC415EB89D877DBD09B21C/2019-06-27YGzd77Cs2QQbwEcszttG.jpg"
				}],
				spaceDstSelect:[{
					name:'aa',
					code:11151,
					id:'801208899*'
				},{
					name:'aaff',
					code:111422,
					id:'8883412099**'
				},
				{
					name:'发发发的',
					code:11133,
					id:'888999***'
				},{
					name:'v水电费',
					code:11184,
					id:'8889898****'
				},{
					name:'是的发',
					code:11015,
					id:'8887979//'
				},{
					name:'aaff',
					code:111426,
					id:'88832544120--99'
				},
				{
					name:'发发发的',
					code:11137,
					id:'8882199559'
				},{
					name:'v水电费',
					code:11188,
					id:'8880.12.998'
				},{
					name:'是的发',
					code:11019,
					id:'88891.79..'
				},{
					name:'aaff',
					code:1114210,
					id:'8883.1.41203399'
				},
				{
					name:'发发发的',
					code:111311,
					id:'8889.4.99'
				},{
					name:'v水电费',
					code:111812,
					id:'888999210.78'
				},{
					name:'是的发',
					code:1101123,
					id:'888997**9'
				}],
				ruleForm: {
					patrolTime: '',
					patrolTime1: '',
					spaceDst:[]
				},
				rules: {
					patrolTime: [{
						required: true,
						message: '请选择巡查时间',
						trigger: 'blur'
					}, ],
					patrolTime1: [{
						required: false,
						message: '请选择巡查时间',
						trigger: 'blur'
					}, ]
				},
				options1: [{
					value: '选项1',
					label: '黄金糕'
				}, {
					value: '选项2',
					label: '双皮奶'
				}, {
					value: '选项3',
					label: '蚵仔煎'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				value1: '',
				input: 'ddd',
				page: {
					pageSize: 10,
					pageNum: 1,
					total: 0
				},
				value: true,
				visible: false,
				options: [{
						value: "选项1",
						label: "黄金糕"
					},
					{
						value: "选项2",
						label: "双皮奶"
					},
					{
						value: "选项3",
						label: "蚵仔煎"
					},
					{
						value: "选项4",
						label: "龙须面"
					},
					{
						value: "选项5",
						label: "北京烤鸭"
					}
				],
				value1: [],
				value2: [],
				tableData: [{
						date: "2016-05-03",
						name: "王小虎",
						address: "上海市普陀区金沙江路 1518 弄"
					},
					{
						date: "2016-05-02",
						name: "王小虎",
						address: "上海市普陀区金沙江路 1518 弄"
					},
					{
						date: "2016-05-04",
						name: "王小虎",
						address: "上海市普陀区金沙江路 1518 弄"
					},
					{
						date: "2016-05-01",
						name: "王小虎",
						address: "上海市普陀区金沙江路 1518 弄"
					},
					{
						date: "2016-05-08",
						name: "王小虎",
						address: "上海市普陀区金沙江路 1518 弄"
					},
					{
						date: "2016-05-06",
						name: "王小虎",
						address: "上海市普陀区金沙江路 1518 弄"
					},
					{
						date: "2016-05-07",
						name: "王小虎",
						address: "上海市普陀区金沙江路 1518 弄"
					}
				],
				multipleSelection: []
			};
		},
		methods: {
			ischange(info){
				console.log(info)
			},
			getFiles(Files,state){
				console.log(Files,state)
			},
			pageCurrentChange(num) {
				if(num !== this.page.pageNum) {
					this.page.pageNum = num;
				}
			},
			pageSizeChange(size) {
				if(size !== this.page.pageSize) {
					this.page.pageSize = size;
				}
			},
			toggleSelection(rows) {
				if(rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			
		},
		created(){
				api
				.login({
					userName: "13324452967",
					password: "666666"
				})
				.then(r => {});
		},
		mounted() {
		
		}
	};
</script>

<style scoped lang='scss'>
	#home {
		width: 100%;
		height: 100%;
		border: 1px solid red;
		padding: 50px 0;
		.box {
			height: 200px;
			width: 200px;
			background: url("~assets/img/logo.png") no-repeat center;
		}
	}
</style>